import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Subscribe from "./Subscribe";

const About = () => {
  const cardsDetails = [
    {
      id: 1,
      name: "SALOMI NAUTIYAL DABRAL",
      role: "Co-Founder & CEO",
    },
    {
      id: 2,
      name: "GOURI SHANKAR BERIHA",
      role: "COO",
    },
    {
      id: 3,
      name: "ARUNDHATI TARIA",
      role: "Lead, Community & Fundraising",
    }
  ];
  return (
    <div>
      <Navbar />
      <div className="container py-3">
        <div className="col text-center">
          <div className="col py-3">
            <p className="fs-1 ">OUR TEAM</p>
          </div>
          <div className="py-3">
            <p>The people who matter</p>
          </div>
          <div className="py-3">
            <p>
              Founded in 2021, our team is comprised of the following folks
              coming from various backgrounds and with varied levels of
              experience. Have a look below to connect with them!
            </p>
          </div>
        </div>

        {/* card */}
        <div className="row row-cols-1 row-cols-md-3 g-4">
          {cardsDetails.map((user, index) => (
            <div className="col my-5">
              <div>
                {/* <img
                  src={user.img}
                  key={index}
                  className="card-img-top"
                  alt={user.name}
                /> */}
                <div className="text-center">
                  <h5 key={index} >
                    {user.name}
                  </h5> <br />
                  <p key={index} >
                    {user.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
          

          <Subscribe />
      <Footer />
    </div>
  );
};

export default About;
